import { Inject, Injectable, signal } from "@angular/core";
import { DataStore } from "../abstract/data-store";
import { DroneInterface } from "../interfaces/drone-interface";
import { WebSocketService } from "../web-socket-handlers/web-socket.service";
import { Drone } from "../data-models/drone";

@Injectable({ providedIn: 'root' })
export class DroneStore extends DataStore<Drone> {
    
    protected override _modelKey: string = 'drones'

    constructor() {
        super('drones', 'drones', 'drone', 'drones')
    }

    protected override createObject(data: {} | any) {
        return {}
    }
    
    
}
